import { render, staticRenderFns } from "./select-discount-type.vue?vue&type=template&id=4006ff56"
import script from "./select-discount-type.vue?vue&type=script&lang=ts"
export * from "./select-discount-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports